export default function duplicateArray(array){
  return JSON.parse(JSON.stringify(array))
}
